import { i18n } from '@lingui/core';
import isObject from 'lodash/isObject';
export var getTranslatedValue = function (column) {
    var _a, _b, _c, _d;
    return column && isObject(column === null || column === void 0 ? void 0 : column.title)
        ? 'props' in column.title &&
            ((_a = column.title) === null || _a === void 0 ? void 0 : _a.props) &&
            i18n._({ id: (_c = (_b = column.title) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.id, message: (_d = column.title) === null || _d === void 0 ? void 0 : _d.props.message })
        : column === null || column === void 0 ? void 0 : column.title;
};
